import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=5b87921a&scoped=true&"
var script = {}
import style0 from "./policy.vue?vue&type=style&index=0&id=5b87921a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b87921a",
  null
  
)

export default component.exports